import { createFileRoute } from "@tanstack/react-router";

import {
  getManageResumeVersionsGuideMetadata,
  ManageResumeVersionsGuide,
} from "@/components/guides/manage-resume-versions";

export const Route = createFileRoute("/_home/guides/manage-resume-versions")({
  component: ManageResumeVersionsGuide,
  head: () => {
    const metadata = getManageResumeVersionsGuideMetadata();

    return {
      meta: [
        { title: metadata.title },
        { name: "description", content: metadata.description },
        { property: "og:title", content: metadata.title },
        { property: "og:description", content: metadata.description },
        { property: "og:url", content: metadata.ogUrl },
        { property: "twitter:title", content: metadata.title },
        { property: "twitter:description", content: metadata.description },
      ],
    };
  },
});
